import React, { useState } from "react";
import "./smartlayout/layout.css";

interface DummyComponentProps {
  title?: string;
  message?: string;
  height?: string;
}

function DummyComponent({
  title = "Dummy Component",
  message = "This is a dummy component",
  height,
}: DummyComponentProps): JSX.Element {
  const [count, setCount] = useState(0);

  return (
    <div className="layout-container" style={{ height }}>
      <div className="layout-header">
        <div className="layout-header-title">{title}</div>
      </div>
      <div style={{ padding: "1rem", flex: 1 }}>
        <p className="color-text-secondary">{message}</p>
        <div style={{ marginTop: "1rem" }}>
          <p className="color-text-primary">Count: {count}</p>
          <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem" }}>
            <button className="btn btn-success" onClick={() => setCount(count + 1)}>
              Increment
            </button>
            <button className="btn btn-danger" onClick={() => setCount(0)}>
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(DummyComponent);
